import { Button, styled } from '@mui/material';

export const DeleteButton = styled(Button)`
  align-items: center;
  column-gap: 1rem;
`;
